import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import { FilterMatchMode } from "primereact/api";
import { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";

const GuideTable = ({ onClick }) => {
  //state
  const [guide, setGuide] = useState({ data: [], load: false });
  const [idDel, setIdDel] = useState(null);
  const [dialogDelete, setDialogDelete] = useState({ data: {}, show: false });
  const [dialogForm, setDialogForm] = useState({
    data: { id: null, judul: "", content: "" },
    show: false,
    edit: false,
    load: false,
  });
  const toast = useRef(null);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  });

  const [globalFilterValue, setGlobalFilterValue] = useState("");

  //function
  const showSuccess = (detail) => {
    toast.current.show({ severity: "success", summary: "Success", detail: detail ?? "success", life: 3000 });
  };

  const showError = (detail) => {
    toast.current.show({ severity: "error", summary: "Error", detail: detail ?? "error", life: 3000 });
  };

  const handleGuide = async () => {
    setGuide({ data: [], load: true });

    try {
      const headers = {
        "Content-Type": "application/json",
        "X-ENDPOINT": "/api/guide/all",
      };

      const response = await fetch("/api/_apibase_crud/", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({}),
      });

      if (!response.ok) {
        setGuide({ data: [], load: false });
        return;
      }

      const data = await response.json();

      if (data.length > 0) {
        setGuide({ data: data, load: false });
      }
    } catch (error) {
      setGuide({ data: [], load: false });
      console.error(error);
    }
  };

  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };

  const onInputChange = (val, name) => {
    let _guide = { ...dialogForm.data };
    _guide[`${name}`] = val;
    setDialogForm({ data: _guide, show: true, edit: false });
  };

  const handleSubmit = async () => {
    setDialogForm({ load: true });

    try {
      let headers;
      if (dialogForm.data.id) {
        headers = {
          "Content-Type": "application/json",
          "X-ENDPOINT": "/api/guide/update",
        };
      } else {
        headers = {
          "Content-Type": "application/json",
          "X-ENDPOINT": "/api/guide/store",
        };
      }

      const response = await fetch("/api/_apibase_crud/", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          id: dialogForm.data?.id,
          content: dialogForm.data?.content,
          judul: dialogForm.data?.judul,
        }),
      });

      if (!response.ok) {
        setDialogForm({
          data: { id: null, judul: "", content: "" },
          edit: false,
          show: false,
          load: false,
        });
        return;
      }

      const data = await response.json();

      if (!data.error) {
        showSuccess("Berhasil menyimpan data");
        setDialogForm({
          data: { id: null, judul: "", content: "" },
          edit: false,
          show: false,
          load: false,
        });
        handleGuide();
      }
    } catch (error) {
      showError("Terjadi kesalahan");
      setDialogForm({
        data: { id: null, judul: "", content: "" },
        edit: false,
        show: false,
        load: false,
      });
      console.error(error);
    }
  };

  const handleDelete = async () => {
    try {
      let headers;

      headers = {
        "Content-Type": "application/json",
        "X-ENDPOINT": "/api/guide/delete",
      };

      const response = await fetch("/api/_apibase_crud/", {
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          id: dialogDelete.data.id,
        }),
      });

      if (!response.ok) {
        setDialogDelete({ show: false, data: {} });
        return;
      }

      const data = await response.json();

      if (!data.error) {
        showSuccess("Berhasil hapus data");
        setDialogDelete({ show: false, data: {} });
        handleGuide();
      }
    } catch (error) {
      showError("Terjadi kesalahan");
      setDialogDelete({ show: false, data: {} });
      console.error(error);
    }
  };
  //

  useEffect(() => {
    handleGuide();
  }, [onClick]);

  // template
  const actionTemplate = (rowData) => {
    return (
      <div className="flex align-items-center justify-content-center gap-2">
        <Button
          icon="pi pi-trash"
          size="small"
          onClick={() => setDialogDelete({ show: true, data: rowData })}
          severity="danger"
        />
        <Button
          icon="pi pi-pencil"
          size="small"
          onClick={() => setDialogForm({ data: rowData, show: true, edit: true })}
        />
      </div>
    );
  };

  const headerTemplate = () => {
    return (
      <div className="flex justify-content-between">
        <div className="flex gap-2">
          <Button
            label="Add"
            size="small"
            icon="pi pi-plus"
            onClick={() =>
              setDialogForm({
                data: { id: null, judul: "", content: "" },
                show: true,
                edit: false,
              })
            }
            severity="success"
          />
          <span className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search" />
          </span>
        </div>
      </div>
    );
  };

  const footerContentTemplate = (
    <div>
      <Button
        label="No"
        icon="pi pi-times"
        onClick={() => setDialogDelete({ show: false, data: {} })}
        className="p-button-text"
      />
      <Button label="Yes" icon="pi pi-check" onClick={() => handleDelete()} />
    </div>
  );
  //

  return (
    <div>
      <Toast ref={toast} />
      <div className="surface-card p-4 border-round">
        <DataTable
          value={guide.data}
          dataKey="id"
          filters={filters}
          filterDisplay="row"
          globalFilterFields={["judul"]}
          emptyMessage="No customers found."
          className="datatable-responsive"
          loading={guide.load}
          header={headerTemplate}
          paginator
          rows={10}>
          <Column header="Judul" field="judul" />
          <Column body={actionTemplate} />
        </DataTable>
      </div>

      <Dialog
        header="Delete"
        visible={dialogDelete.show}
        onHide={() => setDialogDelete({ show: false, data: {} })}
        footer={footerContentTemplate}>
        <div className="flex align-items-center justify-content-center">
          <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: "2rem" }} />
          <span>
            are you sure you want to delete <strong>{dialogDelete.data?.judul}</strong>
          </span>
        </div>
      </Dialog>

      <Dialog
        visible={dialogForm.show}
        header={dialogForm.edit ? "Edit" : "Add"}
        style={{ width: "80%" }}
        onHide={() => setDialogForm({ show: false, data: { id: null, judul: "", content: "" }, edit: false })}>
        <div className="p-fluid">
          <div className="field">
            <label htmlFor="judul">judul</label>
            <InputText
              maxLength={100}
              id="judul"
              type="text"
              value={dialogForm.data?.judul}
              onChange={(e) => onInputChange(e.target.value, "judul")}
            />
            {dialogForm.data?.judul == "" && <span>harus diisi</span>}
          </div>
          <div className="field">
            <label htmlFor="content">Content</label>
            <InputTextarea
              id="content"
              value={dialogForm.data?.content}
              onChange={(e) => onInputChange(e.target.value, "content")}
              rows={5}
              cols={20}
            />
            {dialogForm.data?.content == "" && <span>harus diisi</span>}
          </div>
          <div className="field grid">
            <div className="col flex flex-row justify-content-start align-content-center gap-2">
              <Button
                label="submit"
                loading={dialogForm.load}
                onClick={() => {
                  handleSubmit();
                }}
                severity="success"
                size="small"
              />
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default GuideTable;
